import { ReportStory } from './ReportStory'
import { withReportStory } from './withReportStory'

const ConnectedReportStory = withReportStory(ReportStory)

export { ConnectedReportStory as ReportStory }
